<style type="text/css" media="screen" scoped>
.input-block{
  border: 1px solid #E2E2E2;
  box-sizing: border-box;
  border-radius: 6px;
  width: 38px;
  height: 38px;
  padding: 10px;
  font-family: Nunito Sans;
  font-style: normal;
  font-weight: 900;
  font-size: 18px;
  line-height: 25px;
  text-align: center;
  color: #303030;
}
.input-block:focus{
  border: 2px solid #1DC895 !important;
  /*background-color: #1DC895;*/
  /*color: #FFFF;*/
}
.input-block-wrapper{
  width: 45px;
  height: 45px;
  display: inline-block;
}
</style>

<template>
 <div class="text-center">
   <v-dialog v-model="dialog.flag" persistent width="520" class="br-25" >
    <v-card>
      <!--  close btn -->
      <p class="text-right pr-3" style="margin-bottom:-10px !important">
        <v-icon color="#8F8F8F" small @click="dialog.flag=false">
          mdi-window-close
        </v-icon>
      </p>
      <v-card-text class="flex-column  mb-5 ">
        <!--  dialog title -->
        <p class="page-title text-center">{{$lang.VERIFICATION.toUpperCase()}}</p>
        <v-form ref="verify_withdraw_form"  lazy-validation>
          <div class="mt-8">
            <v-row class="">
              <v-col md="7" class="pt-0">
                <p class="filter-sub-title">{{$lang.WHOLESALER}}</p>
                <p class="sub-title-text">{{dialog.item.firm_name}}</p>
              </v-col>
              <v-col md="5" class="pt-0">
                <div class="d-flex flex-row pt-0 text-left"  flat >
                  <div>
                    <img src="@/assets/calender.svg"  alt="img"  width="18px" class="mt-5">
                  </div>
                  <div class="pa-2 pt-0">
                    <p class="secodry-text-2">{{$lang.DATE}}</p>
                    <p class="sub-title-text text-center">{{dialog.item.created_date}}</p>
                  </div>
                </div>
              </v-col>
            </v-row >
            <v-row >
              <v-col md="7" class="pt-0">
                <p class="filter-sub-title">{{$lang.AMOUNT}}</p>
                <p class="sub-title-text">
                  <img src="@/assets/rupee.svg"  alt="img"  width="11px" class="" style="margin-right:-5px">
                  {{dialog.item.amount}}
                </p>
              </v-col>
              <v-col md="5" class="pt-0">
                <div class="d-flex flex-row pt-0">
                  <div>
                    <img src="@/assets/return-green.svg"  alt="img"  width="18px" class="mt-5">
                  </div>
                  <div class="pa-2 pt-0"  >
                    <p class="secodry-text-2">{{$lang.RETURNS}}</p>
                    <p class="sub-title-text text-center">{{dialog.item.shipment_count}}</p>
                  </div>
                </div>
              </v-col>
              <v-col md="7" class="py-0">
                <p class="secodry-text-2 pb-2">{{$lang.RECIPIENT_NAME}}</p>
                <v-text-field
                v-model="recipient_name"
                :placeholder="$lang.RECIPIENT_NAME"
                outlined
                dense
                single-line
                :rules="$rules.RECIPIENT_NAME"
                ></v-text-field>
              </v-col>
            </v-row >
          </div>
          <!-- OTP  Boxes -->
          <p class="secodry-text-2 pb-2">{{$lang.OTP.toUpperCase()}}</p>
          <div v-for="n in 6" :key="n" class="input-block-wrapper">
            <input type="text" 
            name=""
            :id="'input_'+n"
            class="input-block" maxlength="1" 
            v-model="otp_arry[n-1]" verify_withdraw_form
            @keyup="chageFocus($event,n)">
          </div>

        </v-form>
        <p class="secodry-text-2 mt-2 fw-550 fs-10">{{$lang.WITHDRAWAL_OTP_NOTES}}</p>

      </v-card-text>
      <v-card-actions class="text-center pb-5">
        <v-spacer></v-spacer>
        <v-btn color="primary" width="90" class="fw-bold ml-5" :loading="btn_loading"   @click="verifyWithdraw">  
          {{$lang.CONTINUE}}
        </v-btn>  
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-card>
  </v-dialog>
</div>
</template>


<script>
export default {
  props:["dialog"],
  data () {
    return {
      recipient_name:"",
      btn_loading:false,
      otp_arry:[],

    }
  },
  methods: {
    /* Manging the focus chnage on the inpout box */ 
    chageFocus(event,n){
      const self=this
      const number_key=["1","2","3","4","5","6","7","8","9","0"]
      const key = event.key; 
      if(this.enable_flag==false)
        return false

      this.enable_flag==false
      if (key === "Backspace"||key === "Delete") {
        if (n>1){
          if(key === "Backspace")
            document.getElementById("input_"+(n-1)).focus();
          if(key === "Delete")
            document.getElementById("input_"+(n+1)).focus();

        }
      } 
      else{
        if (number_key.includes(key)==false)
          self.otp_arry[n-1]="";

        if (n<6 && this.otp_arry[n-1]!=" " && number_key.includes(key)){
          if (number_key.includes(key)){
            if(!self.otp_arry[n-1])
              self.otp_arry[n-1]=key;
          }
          if(self.otp_arry[n-1])
            document.getElementById("input_"+(n+1)).focus();
        }
      }
      this.enable_flag==true
    },
    /* Verify Withdrawal */ 
    verifyWithdraw(){
      const self=this;

      if (self.$refs.verify_withdraw_form.validate()==false)
        return false

      let otp=""
      for (var i = 0; i < this.otp_arry.length; i++) {
        otp += this.otp_arry[i].toString();
      } 

      console.log(otp)

      self.btn_loading=true
      var form = new FormData();
      form.append("recipient_name",self.recipient_name);
      form.append("otp",otp);
      form.append("id",self.dialog.item.transaction_id);
      const successHandler = (response) => {
        if(response.data.success){
          self.dialog.flag=false
          this.showSnakeBar("success",response.data.message)
          this.$emit("update-list");

        }
      };
      const finallyHandler = () => {
        self.btn_loading=false
      };

      this.request_POST(self,this.$urls.COMPLETE_WITHDRAW,form,successHandler,null,null,finallyHandler)




    }



  }
}
</script>